export default {
    STORE_KEY: 'a56z0fzrNpl^2',

     
    API_URL: 'https://ikitchen.cz/server/public/api/v1',
    PUBLIC_URL: 'https://ikitchen.cz/server/public/uploads/',
    API_URL_INNER: 'server/public/api/v1',

  };